import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './notice.module.css';

export function MediaUserOnlyInfoNotice() {
  return (
    <p
      className={clsx(
        styles.notice,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
    >
      <span> 以下、メディア関係者限定の特記情報です。</span>
      <span>個人のSNS等での情報公開はご遠慮ください。</span>
    </p>
  );
}
